import React from 'react'

import { Button, Result } from 'antd'
import { ResultStatusType } from 'antd/lib/result'
import { To, useNavigate } from 'react-router-dom'

interface ErrorMsgProps {
  title: string
  status?: ResultStatusType
  backTo?: To
}

export const ErrorMsg: React.FC<ErrorMsgProps> = ({
  title,
  status = 'warning',
  backTo
}) => {
  const navigate = useNavigate()
  return (
    <Result
      status={status}
      title={title}
      extra={
        <Button
          onClick={() => navigate(backTo ? backTo : '../', { replace: true })}
        >
          Back
        </Button>
      }
    />
  )
}
